export default __webpack_public_path__ + "static/media/kids3.1ad0ff89.jpg";